import React, { useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import heartLoading from "../../../../assests/heartLoading.gif";
import LineageTransformationViewer from "./LineageTransformationViewer";
import useLineageTransformationData from "./useLineageTransformationData";

export default function LineageTransformationFullScreenPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const assetName = searchParams.get("assetName") || "";
  const preferredMermaidName = searchParams.get("mermaid") || "";

  const {
    handleSelectMermaid,
    loading,
    mermaidTypes,
    selectedMermaid,
  } = useLineageTransformationData({
    assetName,
    preferredMermaidName,
  });

  useEffect(() => {
    const nextParams = new URLSearchParams(searchParams);

    if (assetName) {
      nextParams.set("assetName", assetName);
    } else {
      nextParams.delete("assetName");
    }

    if (selectedMermaid?.name) {
      nextParams.set("mermaid", selectedMermaid.name);
    } else {
      nextParams.delete("mermaid");
    }

    nextParams.set("viewMode", "mermaid");

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams, { replace: true });
    }
  }, [assetName, searchParams, selectedMermaid, setSearchParams]);

  return (
    <div className="h-screen bg-slate-100">
      <div className="flex h-full flex-col">
        {/* Header */}
        <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-6 py-2 shadow-sm">
          <button
            onClick={() => window.history.back()}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Go back"
          >
            <ChevronLeft size={20} className="text-gray-600" />
          </button>
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
              Lineage Transformation
            </p>
            <h1 className="truncate text-sm font-semibold text-slate-900">
              {assetName || "Full Screen View"}
            </h1>
          </div>
        </div>

        <div className="min-h-0 flex-1 p-0">
          {assetName ? (
            <div className="h-full overflow-hidden rounded-2xl shadow-sm">
              <LineageTransformationViewer
                loading={loading}
                selectedMermaid={selectedMermaid}
                mermaidTypes={mermaidTypes}
                onSelectMermaid={handleSelectMermaid}
                loadingImage={heartLoading}
                loadingMessage="Loading lineage transformation..."
                emptyMessage="No resources found!"
                emptyTextClassName="text-gray-700 text-[20px]"
                rootClassName="h-full flex flex-col min-h-0"
              />
            </div>
          ) : (
            <div className="flex h-full items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white text-center">
              <div className="space-y-2 px-6">
                <p className="text-lg font-semibold text-slate-800">
                  No asset selected
                </p>
                <p className="text-sm text-slate-500">
                  Open this page from the lineage transformation viewer to load the full screen view.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}